import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash-es';
import { TaskQueueDetail, TaskMessage, QIResultStatus, AddVersionType, TaskFileDetail } from 'common/types';
import service from '@/service';
import { RootState } from './index';
import { AppThunk } from '.';
import { setUploadingQueue } from './uploadingTaskQueue';
import { parseFileToStore } from './addVersion';

interface TaskQueueInitialStateProp {
  taskQueue: TaskQueueDetail[];
  isTaskQueueShow: boolean;
}
const initialState: TaskQueueInitialStateProp = {
  taskQueue: [],
  isTaskQueueShow: false,
};
const taskQueue = createSlice({
  name: 'taskQueue',
  initialState,
  reducers: {
    setTaskQueue: (state, { payload }: PayloadAction<TaskQueueDetail[]>) => {
      state.taskQueue = payload;
    },
    setIsTaskQueueShow: (state, { payload }: PayloadAction<boolean>) => {
      state.isTaskQueueShow = payload;
    },
  },
});
export const { setTaskQueue, setIsTaskQueueShow } = taskQueue.actions;
export const selectIsTaskQueueShow = (state: RootState) => state.taskQueue.isTaskQueueShow;
export const selectAllTasksQueue = (state: RootState) => {
  const tasksInRedis = Array.isArray(state.taskQueue.taskQueue) ? state.taskQueue.taskQueue : [];
  const uploadingTasks = state.uploadingTaskQueue.queue || [];
  return [...tasksInRedis, ...uploadingTasks];
};
export const countTaskingQueues = (state: RootState) => {
  const tasksInRedis = Array.isArray(state.taskQueue.taskQueue) ? state.taskQueue.taskQueue : [];
  const uploadingTasks = state.uploadingTaskQueue.queue || [];
  const taskList = [...tasksInRedis, ...uploadingTasks];
  const taskingQueues = taskList.filter(
    task => task.taskStatus?.result !== QIResultStatus.UPLOAD_SUCCESS && task.type === AddVersionType.Version,
  );
  const uploadAssetQueues = taskList.filter(
    task => task.taskStatus?.result !== QIResultStatus.UPLOAD_SUCCESS && task.type === AddVersionType.ArtAsset,
  );
  return {
    versionCounts: taskingQueues.length,
    assetCounts: uploadAssetQueues.length,
  };
};

export const getTaskQueue = (): AppThunk => async (dispatch, getState) => {
  const res = await service.taskQueue.getListBackground();
  const { data } = res || {};
  data && dispatch(setTaskQueue(data));
};

export const updateTaskQueue =
  (newTaskMessage: Partial<TaskMessage>, fileList: TaskFileDetail[]): AppThunk =>
  async (dispatch, getState) => {
    const allTasks = getState()?.taskQueue?.taskQueue;

    const { uuid } = newTaskMessage;

    let newTasks: TaskQueueDetail[] = [];
    newTasks = allTasks.map(task => {
      let newTask = { ...task };
      if (task.uuid === uuid) {
        const newFileList = fileList.map(file => parseFileToStore(file));
        newTask = { ...newTask, ...newTaskMessage, fileList: newFileList };
      }
      return newTask;
    });

    dispatch(setTaskQueue([...newTasks]));
  };

export const deleteTaskQueue =
  (versionId: string): AppThunk =>
  async (dispatch, getState) => {
    const tasksInRedis = getState()?.taskQueue?.taskQueue;
    const tasksInCache = getState()?.uploadingTaskQueue.queue;
    const isInRedis = tasksInRedis?.some(task => task.uuid === versionId);
    if (isInRedis) {
      const newTasks = tasksInRedis.filter(task => task.uuid !== versionId);
      dispatch(setTaskQueue([...newTasks]));
      await service.taskQueue.deleteBackgroundVersion({ versionId });
    } else {
      const newTasks = tasksInCache.filter(task => task.uuid !== versionId);
      dispatch(setUploadingQueue([...newTasks]));
    }
  };
export default taskQueue.reducer;
